<app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

<div class="container px-0 mt-5">
    <div class="grid grid-cols-3 gap-4">
        <div class="col-span-2">
            <form [formGroup]="departmentForm">
                <mat-form-field class="w-full">
                    <mat-label>{{'COMMON.NAME' | translate}}</mat-label>
                    <input formControlName="name" class="border-transparent focus:border-transparent focus:ring-0"
                        matInput />
                    @if (departmentForm.controls['name'].hasError('required')) {
                    <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                    }
                </mat-form-field>
                <ng-container *ngIf="isAddMode">
                    <mat-form-field class="w-full" (click)="onClickSelectDepartment()">
                        <mat-label>{{'DEPARTMENTS.DEPARTMENT' | translate}}</mat-label>
                        <input formControlName="departmentText" readonly
                            class="border-transparent focus:border-transparent focus:ring-0" matInput placeholder="" />
                        <button matSuffix mat-icon-button>
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                        @if (departmentForm.controls['id'].hasError('required')) {
                        <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="w-full">
                        <mat-label>{{'COMMON.DESCRIPTION' | translate}}</mat-label>
                        <textarea formControlName="description"
                            class="border-transparent focus:border-transparent focus:ring-0" matInput maxlength="4000"
                            cdkAutosizeMinRows="3" #autosize="cdkTextareaAutosize" cdkTextareaAutosize></textarea>
                        <mat-hint align="end">{{ departmentForm.controls['description'].value.length }} /
                            4000</mat-hint>
                    </mat-form-field>
                </ng-container>
            </form>
        </div>
        <div></div>
    </div>
    <div class="col-span-2">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" *ngIf="!isAddMode" (selectedTabChange)="selectedTabChange($event)">
            <mat-tab label="{{'COMMON.INFORMATION' | translate}}">
                <ng-template matTabContent>
                    <div class="mt-5 grid grid-cols-3">
                        <div class="col-span-2">
                            <form [formGroup]="departmentForm">
                                <mat-form-field class="w-full">
                                    <mat-label>{{'DEPARTMENTS.DEPARTMENT' | translate}}</mat-label>
                                    <input formControlName="departmentText" readonly
                                        class="border-transparent focus:border-transparent focus:ring-0" matInput
                                        placeholder="" />
                                    <button (click)="onClickSelectDepartment()" matSuffix mat-icon-button>
                                        <mat-icon>arrow_drop_down</mat-icon>
                                    </button>
                                    @if (departmentForm.controls['id'].hasError('required')) {
                                    <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field class="w-full">
                                    <mat-label>{{'COMMON.DESCRIPTION' | translate}}</mat-label>
                                    <textarea formControlName="description" cdkAutosizeMinRows="3"
                                        class="border-transparent focus:border-transparent focus:ring-0" matInput
                                        maxlength="4000" #autosize="cdkTextareaAutosize" cdkTextareaAutosize></textarea>
                                    <mat-hint align="end">{{ departmentForm.controls['description'].value.length }} /
                                        4000</mat-hint>
                                </mat-form-field>
                            </form>
                        </div>
                    </div>
                </ng-template>
            </mat-tab>
            <mat-tab label="Employees">
                <ng-template matTabContent>
                    <div class="mt-5">
                        <form class="example-form">
                            <div class="example-container">
                                <mat-form-field class="example-form-field">
                                    <mat-label>{{'COMMON.SEARCH' | translate}}</mat-label>
                                    <input class="border-transparent focus:border-transparent focus:ring-0"
                                        [(ngModel)]="filter.keyWord" matInput type="text"
                                        (keydown.enter)="searchByKeyword()" [ngModelOptions]="{standalone: true}"
                                        placeholder="{{'COMMON.SEARCH' | translate}}">
                                    <button matSuffix mat-icon-button aria-label="Clear">
                                        <mat-icon>search</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </form>
                        <div class="mt-5">
                            <table mat-table style="width: 100%; min-width: 600px;" class="ws-table"
                                [dataSource]="dataSource">
                                <!-- Position Column -->
                                <ng-container matColumnDef="fullName">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{'COMMON.NAME' | translate}}
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.fullName}} </td>
                                </ng-container>

                                <!-- Name Column -->
                                <ng-container matColumnDef="username">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{'COMMON.USER_NAME' | translate}}
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.username}} </td>
                                </ng-container>

                                <!-- Weight Column -->
                                <ng-container matColumnDef="workPhone">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{'COMMON.WORK' | translate}}
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.workPhone}} </td>
                                </ng-container>

                                <!-- Symbol Column -->
                                <ng-container matColumnDef="mobilePhone">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{'COMMON.MOBILE' | translate}}
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.mobilePhone}} </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>

                            <qms-paginator [length]="totalCount >= 0 ? totalCount : 0" [pageSize]="filter.pageSize"
                                [pageSizeOptions]="[10, 25, 100]" (page)='pageEvent($event)' [size]='"medium"'>
                            </qms-paginator>

                        </div>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>

        <div class="flex justify-end mt-5">
            <button class="me-5" [routerLink]="['/admin/departments']" color="primary" mat-stroked-button>
                {{'COMMON.CANCEL' |translate}}
            </button>

            <button color="primary" (click)="onSubmit()" mat-flat-button>
                {{'COMMON.SAVE' |translate}}
            </button>
        </div>
    </div>
</div>